<template>
  <div class="row justify-content-center">
    <div class="col-lg-5 col-md-7">
      <div class="card bg-secondary shadow border-0">
        <form role="form" name="form" v-on:submit.prevent="handlePasswordChange">
          <div class="card-header bg-transparent pb-5">
            <div class="text-center text-muted mb-4">
              {{$t($route.name+'.title')}}<br>
              <small>{{$t($route.name+'.newPasswordAsk')}}</small>
            </div>

            <!-- email -->
            <div class="form-group" :class="{ error: v$.email.$errors }">
              <base-input
                formClasses="input-group-alternative"
                v-bind:placeholder="$t('register.email')"
                type="text"
                addon-left-icon="ni ni-email-83"
                v-model="v$.email.$model"
              >
              </base-input>
                <!-- error message -->
              <div class="input-errors" v-for="(error, index) of v$.email.$errors" :key="index">
                <div class="error-msg"><small>{{$t(error.$message)}}</small></div>
              </div>
            </div>

            <!-- password -->
            <div class="form-group" :class="{ error: v$.password.$errors.length }">
              <base-input
                formClasses="input-group-alternative has-danger"
                v-bind:placeholder="$t('register.password')"
                type="password"
                addon-left-icon="ni ni-lock-circle-open"
                v-model="v$.password.$model"
              >
              </base-input>
                <!-- error message -->
              <div class="input-errors" v-for="(error, index) of v$.password.$errors" :key="index">
                <div class="error-msg"><small>{{$t(error.$message)}}{{error.$params.min}}</small></div>
              </div>
            </div>

            <!-- confirmPassword -->
            <div class="form-group" :class="{ error: v$.confirmPassword.$errors.length }">
              <base-input
                formClasses="input-group-alternative has-danger"
                v-bind:placeholder="$t('register.confirmPassword')"
                type="password"
                addon-left-icon="ni ni-lock-circle-open"
                v-model="v$.confirmPassword.$model">
              </base-input>
                <!-- error message -->
              <div class="input-errors" v-for="(error, index) of v$.confirmPassword.$errors" :key="index">
                <div class="error-msg"><small>{{$t(error.$message)}}</small></div>
              </div>
              <small
                >{{$t('register.passStrength')}}:
              <span v-bind:class="pass.color+' font-weight-700'">{{$t(pass.strength)}}</span></small>
            </div>
            <div class="text-center">
              <base-button 
                type="primary" 
                native-type="submit"
                class="my-4"
                :disabled="v$.$invalid">
                {{ $t(this.$route.name+'.changePasswordButton') }}
              </base-button>
            </div>
        </div>
      </form>
      </div>
    </div>
    <modal :show="modals.modal3"
        body-classes="p-0"
        modal-classes="modal-dialog-centered modal-sm">
      <card type="secondary" shadow
            header-classes="bg-white pb-5"
            body-classes="px-lg-4 py-lg-5"
            class="border-0"
      >     
        {{ this.message }}
            <base-button 
              type="primary"
              class="btn btn-block btn-warning"
              v-on:click="handleModal"
              >
            {{ $t('login.cancelButton') }}
            <br>
            </base-button>
      </card>
    </modal>
  </div>
</template>
<script>
import useVuelidate from '@vuelidate/core'
import { required, minLength, email, sameAs, helpers } from '@vuelidate/validators'
import User from '../../models/user';
import Modal from "@/components/Modal.vue";

const passStrengthRegex = helpers.regex(/^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\\$%\\^&\\*])(?=.{8,})/)

const pass_colors = {
  low: "text-danger",
  mid: "text-warning",
  high: "text-success"
};

export default {
  name: "password_restore",
  setup () {
    return { v$: useVuelidate() }
  },
  components: {
    Modal
  },
  methods : {
    handlePasswordChange() {
      this.user.email = this.email;
      this.user.password = this.password;
      this.user.key = this.$route.query.key;
      this.$store.dispatch('auth/passwordChange', this.user).then(
        () => {
          this.message = this.$t(this.$route.name+'.passwordChanged');
          this.modals.modal3 = true;
          this.passwordChanged = true;
        },
        error => {
          if(error.response.status==404){
            if(error.response.data.detail.includes("email doesn't exist")){
              this.message = this.$t(this.$route.name+'.emailNotFound');
              this.modals.modal3 = true;
            }else{
              console.log(error)
            }
          } else if (error.response.status==409){
            if(error.response.data.detail.includes("Key")){
              this.message = this.$t(this.$route.name+'.keyError');
              this.modals.modal3 = true;
            }else{
              console.log(error)
            }
          }
        }
      );
    },
    handleModal(){
      if(this.passwordChanged){
        this.passwordChanged = false;
        this.$router.push('/login');
          
      }else{
        this.modals.modal3 = false;
      }
    }
  },
  computed: {
    passwordNew(){
      return this.password;
    },
  },
  watch: {
    passwordNew(password) {
      let strongRegex = new RegExp("^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\\$%\\^&\\*])(?=.{8,})");
      let mediumRegex = new RegExp("^(((?=.*[a-z])(?=.*[A-Z]))|((?=.*[a-z])(?=.*[0-9]))|((?=.*[A-Z])(?=.*[0-9])))(?=.{6,})");

      if (strongRegex.test(password)){
        this.pass.color = pass_colors.high;
        this.pass.strength = 'register.passHighStrength';
      } else if (mediumRegex.test(password)){
        this.pass.color = pass_colors.mid;
        this.pass.strength = 'register.passMidStrength';
      } else {
        this.pass.color = pass_colors.low;
        this.pass.strength = 'register.passLowStrength';
      }
    },
  },
  validations() {
    return {
      email: {
        required_custom: helpers.withMessage('login.errorFieldRequired', required),
        email: helpers.withMessage('login.errorFieldEmail', email),
      },
      password: {
        required_custom: helpers.withMessage('register.errorFieldRequired', required), 
        min: helpers.withMessage('register.errorInvalidLength', minLength(6)),
        pass_str: helpers.withMessage('register.errorPassStrength',passStrengthRegex),
      },
      confirmPassword: {
        required_custom: helpers.withMessage('register.errorFieldRequired', required),
        sameAsPassword: helpers.withMessage('register.errorPassConfirm', sameAs(this.password)),
      },
    }
  },
  data() {
    return {
      user: new User(null, null, null, null),
      email: null,
      password: null,
      confirmPassword: null,
      pass: {
        strength: 'register.passLowStrength',
        color: pass_colors.low,
      },
      modals: {
        modal3: false,
      },
      message: "",
      passwordChanged: false,
    };
  },
};
</script>
<style></style>